import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import Drawer from '../Drawer/Drawer'
import Card from '../Card/Card'
import ValidateButton from '../ValidateButton/ValidateButton'
import EditResponse from '../EditResponse/EditResponse'
import { IStepState } from '../Step/Step'
import { tag } from '../../services/ATInternetService'

// Import image
import imageStepAge from '../../assets/img/StepAge.jpg'

export interface IStepAgeState {
  selectedValue: number
}

interface IStepAgeProps {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  stepState: IStepState
  onChange: (change: object) => void
  onResetAnswer: () => void
}

@inject('UserStore', 'LayoutStore')
@observer
class StepAge extends React.Component<IStepAgeProps, IStepAgeState> {
  public constructor(props: IStepAgeProps) {
    super(props)
    this.state = {
      selectedValue: this.props.UserStore!.age === null ? 40 : this.props.UserStore!.age,
    }
  }

  public render() {
    const values = []

    for (let i = 18; i < 75; i++) {
      values.push({
        label: `${i} ans`,
        value: i,
      })
    }

    values.push({
      label: `75 ans et plus`,
      value: 75,
    })

    return (
      <>
        <div className="Row Row--mw500">
          <label htmlFor="age">Quel est votre âge ?</label>
        </div>
        <div className="Row Row--center">
          {this.props.stepState.isAnswered && (
            <>
              <Card
                image={imageStepAge}
                label={`${this.props.UserStore!.age} ${
                  this.props.UserStore!.age === 75 ? 'ans et plus' : 'ans'
                }`}
                variant="response"
              />
              <EditResponse functionEdit={this.props.onResetAnswer} />
            </>
          )}
        </div>

        {!this.props.stepState.isAnswered && (
          <Drawer>
            <div className="Drawer-select">
              <select
                defaultValue={`${
                  this.props.UserStore!.age === null ? 40 : this.props.UserStore!.age
                }`}
                onChange={this.validateSelection}
                name="age"
                id="age"
              >
                {values.map((element, index) => {
                  return (
                    <option key={`age-option-${element.value}`} value={element.value}>
                      {element.label}
                    </option>
                  )
                })}
              </select>
            </div>
          </Drawer>
        )}

        {!this.props.stepState.isAnswered && this.props.stepState.needValidation && (
          <div className="control-color-wrapper">
            <ValidateButton onClick={this.setAge} />
          </div>
        )}
      </>
    )
  }

  private validateSelection = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedValue: parseInt(e.target.value, 10) })
    this.props.onChange({ needValidation: true })
  }

  private setAge = () => {
    tag.sendPage({ elem: this, name: 'age_ok', chapter1: 'Questionnaire' })
    this.props.UserStore!.setAge(this.state.selectedValue)
    this.props.onChange({ isAnswered: true })
  }
}

export default StepAge



// WEBPACK FOOTER //
// ./src/components/StepAge/StepAge.tsx